import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Home from '@/components/home'
import Solution from '@/components/solution.vue'

import Media from '@/components/media.vue'
import Travel from '@/components/travel.vue'
import Recruit from '@/components/recruit.vue'
import Channel from '@/components/travel/channel-cases.vue'
import Offline from '@/components/travel/offline-store.vue'
import Group from '@/components/travel/group-buying.vue'
import Portus from '@/components/solution/portus.vue'
import PortusAir from '@/components/solution/portus-air.vue'

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push (location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
export default new Router({
	mode: 'history',
	scrollBehavior (to, from, savedPosition) {
		if (to.query.el && document.querySelector(to.query.el)) {
			if (!to.meta) {
				to.meta = {};
			}
			to.meta.savedPosition = document.querySelector(to.query.el).offsetTop;
		}
		//保存每个页面的滚动位置
		if (savedPosition) {
			return savedPosition
		} else {
			if (from.meta.keepAlive) {
				from.meta.savedPosition = document.documentElement.scrollTop || document.body.scrollTop;
			}
			return {
				x: 0,
				y: to.meta.savedPosition || 0
			}
		}
	},
	routes: [
		{
			path: '/',
			component: Index,
			redirect: '/home',
			children: [
				{
					path: 'home',
					name: 'home',
					component: Home
				}, {
					path: 'solution',
					component: Solution
				}, {
					path: 'media',
					component: Media,
					meta: {
						keepAlive: true
					}
				}, {
					path: 'travel',
					component: Travel,
				}, {
					path: 'recruit',
					component: Recruit
				}, {
					path: 'channel',
					component: Channel
				}, {
					path: 'offline',
					component: Offline
				}, {
					path: 'group',
					component: Group
				}, {
					path: 'portus',
					component: Portus
				}, {
					path: 'portus-air',
					component: PortusAir
				}, {
					path: '*',
					redirect: '/home'
				}
			]
		}
	]
})
